import { StyledSkeleton } from "components/StyledSkeleton/StyledSkeleton";

export function FinalScorecardSkeleton() {
  return (
    <div>
      <StyledSkeleton
        data-skeleton-name="SCORECARD"
        style={{
          width: "100%",
          height: 50,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="SCORECARD"
        style={{
          width: "100%",
          height: 200,
        }}
      />
      <StyledSkeleton
        data-skeleton-name="SCORECARD"
        style={{
          width: "100%",
          height: 20,
        }}
      />
    </div>
  );
}
